module.exports = __webpack_public_path__ + "img/2.c2ed3941.png";